import { z } from 'zod'

import { Pagination } from 'app/types/app/request'
import { Client } from 'app/types/park/client'

export const Technician = z.object({
    id: z.number().positive(),
    client: Client.array(),
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    serial_number: z.string().min(1),
    card_id: z.string().min(1),
    can_code_product: z.boolean(),
})

export type Technician = z.infer<typeof Technician>

export const TechnicianPayload = Technician.omit({
    id: true,
}).extend({
    client: Client.shape.id.array().optional(),
})

export type TechnicianPayload = z.infer<typeof TechnicianPayload>

export const TechniciansRequest = Pagination.extend({
    results: Technician.array(),
})

export type TechniciansRequest = z.infer<typeof TechniciansRequest>
